import { RadioGroup as ChakraRadioGroup, RadioGroupRootProps } from '@chakra-ui/react'
import { Flex } from 'components'
import { startCase } from 'lodash-es'
import { ReactNode } from 'react'
import { TextProps } from '.'

export interface Props<T extends string>
  extends Omit<RadioGroupRootProps, 'children' | 'onChange' | 'onValueChange'> {
  colorScheme?: string
  horizontal?: boolean
  onChange?: (value: T) => void
  options: Option<T>[]
  textProps?: TextProps
  value?: T
}

interface Option<T extends string> {
  label?: ReactNode
  value: T
}

export default function RadioGroup<T extends string>({
  horizontal,
  options,
  onChange,
  textProps,
  ...rest
}: Props<T>) {
  return (
    <ChakraRadioGroup.Root
      colorPalette="primary"
      asChild
      size="md"
      onValueChange={onChange ? e => onChange(e.value as T) : undefined}
      {...rest}
    >
      <Flex
        direction={horizontal ? 'row' : 'column'}
        gap={horizontal ? 4 : 2}
        align={horizontal ? 'flex-end' : 'flex-start'}
        position="relative"
        width="100%"
      >
        {options.map(({ value, label }) => (
          <ChakraRadioGroup.Item key={value} cursor="pointer" value={value}>
            <ChakraRadioGroup.ItemHiddenInput />
            <ChakraRadioGroup.ItemIndicator />
            <ChakraRadioGroup.ItemText {...textProps}>
              {label ?? startCase(value)}
            </ChakraRadioGroup.ItemText>
          </ChakraRadioGroup.Item>
        ))}
      </Flex>
    </ChakraRadioGroup.Root>
  )
}
